import { render } from "./editDetailsModal.vue?vue&type=template&id=68b7c43e"
import script from "./editDetailsModal.vue?vue&type=script&lang=js"
export * from "./editDetailsModal.vue?vue&type=script&lang=js"

import "./editDetailsModal.vue?vue&type=style&index=0&id=68b7c43e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__